module.exports = __webpack_public_path__ + "static/media/subway.2d7b496d.svg";